import copy from "copy-to-clipboard";
import React, { useCallback, useEffect } from "react";
import classNames from "classnames";
import { Button, Col, Input, Layout, Row, Space, Typography, message } from "@payping/web-components";
import { CheckCircleFilled, CopyFilled } from "@payping/icons";
import type { InvoiceCreateResponseViewModel } from "@payping/api";
import { useLocation, useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";

import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "./styles.module.scss";
import { URLS } from "@payping/utilities-shared/consts";

const Callback: React.FC = () => {
  // =========================================
  // Init
  // =========================================
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const location = useLocation() as { state: InvoiceCreateResponseViewModel[] };

  const goToList = useCallback(() => navigate({ pathname: DashboardRoutes.myShop.invoice.root.url }), [navigate]);

  useEffect(() => {
    // redirect to list if there is no code
    if (!location?.state) goToList();
  }, [goToList, location?.state]);

  return (
    <>
      <Layout className="tw:my-0! tw:mx-auto tw:w-[500px] tw:min-w-[500px]">
        <CheckCircleFilled className={classNames(styles.successIcon, "color--success")} width={"7rem"} />
        <Typography.Text className="tw:mb-8! tw:mt-4! tw:text-center" strong>
          {t("invoice.callback.successMessage")}
        </Typography.Text>
        <Row className="tw:w-full" gutter={[0, 16]}>
          {location.state?.map(({ code }, index) => {
            const link = `${URLS.PPNG_URL}/v/${code}`;
            return (
              <Col span={24} key={index}>
                <Space.Compact className={"tw:w-full"}>
                  <Button
                    className={styles.groupButton}
                    onClick={() => {
                      if (code) {
                        const copied = copy(link);
                        if (copied) message.success({ content: t("invoice.callback.copied") });
                      }
                    }}
                  >
                    {t("copy")}
                    <CopyFilled className={"color--cta"} width={"20px"} />
                  </Button>
                  <Input value={link} />
                </Space.Compact>
              </Col>
            );
          })}
        </Row>
      </Layout>
    </>
  );
};

export default Callback;
